export default {
    data: () => ({
        translations: {
            title: {
                el: "Αρχικοί Online/Offline πόντοι κατά την εγγραφή",
                en: "Initial Online/Offline points upon registration",
                it: "Punti iniziali online/offline al momento della registrazione"
            },
            info: {
                el: "Ορίστε τους online/offline πόντους που θα δίνονται στους νέους χρήστες κατά την εγγραφή τους, καθώς και τα όρια χρηστών οι οποίοι θα τα παραλάβουν. Αν θέλετε να είναι απεριόριστοι τσεκάρετε την επιλογή 'Απεριόριστοι χρήστες online/offline' αντίστοιχα. Έχουν αποσταλεί συνολικά σε 718 Χρήστες.",
                en: `
                    Set the online / offline points to be given to new users when
                    registering, as well as the limits of users who will receive them. If
                    you want to be unlimited uncheck 'Unlimited users online / offline'
                    respectively.
                `,
                it: "Definisci i punti online/offline che saranno dati ai nuovi utenti quando si registrano, così come i limiti degli utenti che li riceveranno. Se vuoi che siano illimitati seleziona l'opzione 'Utenti online/offline illimitati' rispettivamente. Sono stati inviati a un totale di 718 utenti."
            },
            totallySent: {
                el: "",
                en: "Totally sent to",
                it: ""
            },
            users: {
                el: "Χρήστες",
                en: "Users.",
                it: "Utenti"
            },
            usersOnline: {
                el: "Απεριόριστοι χρήστες online",
                en: "Unlimited users online",
                it: "Utenti illimitati online"
            },
            onlinePoints: {
                el: "Online Πόντοι",
                en: "Online Points",
                it: "Punti online"
            },
            usersOnlineTotal: {
                el: "Όριο χρηστών για online εγγραφές",
                en: "Max users to register online",
                it: "Limite utente per le registrazioni online"
            },
            usersOffline: {
                el: "Απεριόριστοι χρήστες offline",
                en: "Unlimited users offline",
                it: "Utenti illimitati offline"
            },
            offlinePoints: {
                el: "Offline Πόντοι",
                en: "Offline Points",
                it: "Punti offline"
            },
            usersOfflineTotal: {
                el: "Όριο χρηστών για offline εγγραφές",
                en: "Max users to register offline",
                it: "Limite utente per le registrazioni offline"
            },
            defineUsers: {
                el: "",
                en: "I want to define users as a whole",
                it: ""
            },
            usersTotal: {
                el: "Για πόσους χρήστες συνολικά",
                en: "How many users in total",
                it: "Per quanti utenti in totale"
            },
            firstScan: {
                el: "Πόντοι από την πρώτη σάρωση της κάρτας",
                en: "Points from first-scan of loyalty card",
                it: "Punti dalla prima scansione della carta"
            },
            limitError: {
                el: "Ο αριθμός χρηστών έχει ξεπεραστεί.",
                en: "First scan loyalty card points",
                it: "Gli utenti hanno superato il limite."
            },
            totalOnlineUsers: {
                el: "Συνολικοί Online χρήστες:",
                en: "Total Online Users:",
                it: "Online Utenti totali:"
            },
            totalOfflineUsers: {
                el: "Συνολικοί Offline χρήστες:",
                en: "Total Offine Users:",
                it: "Offline Utenti totali:"
            },
            totalUsers: {
                el: "Συνολικοί χρήστες:",
                en: "Total Users",
                it: "Utenti totali:"
            },
            firstOffRegistered: {
                el: "Εγγεγραμμένος χρήστης",
                en: "Registered user",
                it: "Utente registrato"
            },
            firstOffCustomer: {
                el: "Εγγεγραμμένος χρήστης μέσω φόρμας πελάτη",
                en: "Registered user through customer form",
                it: "Utente registrato tramite modulo cliente"
            },
            firstOnlyNew: {
                el: "Μόνο για πρόσφατα εγγεγραμμένους χρήστες",
                en: "Only to newly registered users",
                it: "Solo per i nuovi utenti registrati"
            },
        }
    })
};
